var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psBackButton"},[_c('i',{staticClass:"el-icon-arrow-left",on:{"click":_vm.back}})])
}
var staticRenderFns = []

export { render, staticRenderFns }